import { useMemo } from 'react';

import type {
    DeveloperPromoConfig,
    SamoletPlusConfig,
    SamoletPlusName
} from './types';
import { useDeveloperPromoConfigsContext } from './DeveloperPromoConfigsProvider';

export type UseDeveloperPromoType = {
    name?: 'samolet';
    config?: DeveloperPromoConfig;
} | {
    name?: SamoletPlusName;
    config?: SamoletPlusConfig;
}

const useDeveloperPromo = (regionId?: number): UseDeveloperPromoType => {
    const { developerPromoConfigs } = useDeveloperPromoConfigsContext();

    const developerPromo = useMemo<UseDeveloperPromoType>(() => {
        if (regionId) {
            const samoletPlusRegionList = developerPromoConfigs.samoletPlus?.regionList ?? [];

            if (samoletPlusRegionList.includes(regionId)) {
                return {
                    name: 'samoletPlus',
                    config: developerPromoConfigs?.samoletPlus
                };
            }
        }

        return { name: undefined, config: undefined };
    }, [ regionId ]);

    return developerPromo;
};

export default useDeveloperPromo;
